import LazyVideo from "@/components/LazyVideo";
import { Tag, Filter, Search, FolderOpen, Layers, Sparkles, Eye } from "lucide-react";
import FeaturePageLayout from "@/components/feature-page/FeaturePageLayout";
import FeaturePageHero from "@/components/feature-page/FeaturePageHero";
import FeaturePageContent from "@/components/feature-page/FeaturePageContent";
import type { FeatureCard } from "@/components/feature-page/FeaturePageContent";
import tagsLabelsDemo from "@/assets/tags-labels-demo.mov";
import tagsDitchDetective from "@/assets/tags-ditch-detective.png";
import tagsPhotoLibrarian from "@/assets/tags-photo-librarian.png";
import tagsOrganize from "@/assets/tags-organize.png";
import tagsDriversSeat from "@/assets/tags-drivers-seat.png";

const capabilities = [
  { icon: Tag, titleKey: "tagsLabels.features.customTags.title", descKey: "tagsLabels.features.customTags.desc" },
  { icon: Filter, titleKey: "tagsLabels.features.smartFilters.title", descKey: "tagsLabels.features.smartFilters.desc" },
  { icon: FolderOpen, titleKey: "tagsLabels.features.projectLabels.title", descKey: "tagsLabels.features.projectLabels.desc" },
  { icon: Search, titleKey: "tagsLabels.features.instantSearch.title", descKey: "tagsLabels.features.instantSearch.desc" },
];

const cards: FeatureCard[] = [
  {
    image: tagsDitchDetective, titleKey: "tagsLabels.cards.ditchDetective.title", descKey: "tagsLabels.cards.ditchDetective.desc", badgeKey: "tagsLabels.cards.ditchDetective.badge",
    tags: [{ icon: Search, label: "Instant search" }, { icon: Tag, label: "Auto-tagged" }, { icon: Sparkles, label: "AI-powered" }],
  },
  {
    image: tagsPhotoLibrarian, titleKey: "tagsLabels.cards.photoLibrarian.title", descKey: "tagsLabels.cards.photoLibrarian.desc", badgeKey: "tagsLabels.cards.photoLibrarian.badge",
    tags: [{ icon: FolderOpen, label: "Organized library" }, { icon: Filter, label: "Smart filters" }, { icon: Layers, label: "By project" }],
  },
  {
    image: tagsOrganize, titleKey: "tagsLabels.cards.organizeNeverBefore.title", descKey: "tagsLabels.cards.organizeNeverBefore.desc", badgeKey: "tagsLabels.cards.organizeNeverBefore.badge",
    tags: [{ icon: Tag, label: "Custom tags" }, { icon: FolderOpen, label: "Labels" }, { icon: Layers, label: "Categories" }],
  },
  {
    image: tagsDriversSeat, titleKey: "tagsLabels.cards.driversSeat.title", descKey: "tagsLabels.cards.driversSeat.desc", badgeKey: "tagsLabels.cards.driversSeat.badge",
    tags: [{ icon: Eye, label: "Overview" }, { icon: Filter, label: "Quick filters" }],
  },
];

const TagsLabels = () => {
  return (
    <FeaturePageLayout>
      <FeaturePageHero
        badgeKey="tagsLabels.badge"
        titleKey="tagsLabels.title"
        subtitleKey="tagsLabels.subtitle"
        media={<LazyVideo src={tagsLabelsDemo} className="rounded-2xl shadow-2xl max-w-md w-full" />}
        capabilities={capabilities}
      />
      <FeaturePageContent
        sectionDescKey="tagsLabels.searchOverDesc"
        sectionTitleKey="tagsLabels.searchOver"
        sectionSubtitleKey="tagsLabels.searchOverSubtitle"
        cards={cards}
      />
    </FeaturePageLayout>
  );
};

export default TagsLabels;
